import { useNavigate, useParams } from "react-router";

import { useDialog } from "@datanac/datanac-mui-toolkit";
import { IconButton } from "@mui/material";
import { CropIcon } from "components/Icons/Icons";
import { formatNumber } from "utility/formatters";

import { TilleyCard } from "../../../Cards/TilleyCard";
import { DeleteIcon } from "../../../Icons/Icons";

export default function BaseAcresCard({ producerFarm, baseAcres, onChange }) {
  const navigate = useNavigate();
  const { crop_year, location_state_name, location_county_name } = useParams();

  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();
  const handleDeleteOnClick = () => {
    confirmDialogActions.confirm({
      title: "Delete this entry?",
      prompt: "Are you sure you want to delete this entry?",
      promptDetail: null,
      callback: () => {
        const _newState = { ...baseAcres };
        _newState.is_active = false;
        onChange?.(_newState);
      },
    });
  };

  return (
    <>
      <TilleyCard
        data-testid={`base-acres-${baseAcres?.id}`}
        onClick={() =>
          navigate(
            `/vault/${crop_year}/${location_state_name}/${location_county_name}/${producerFarm?.id}/baseAcre/${baseAcres?.id}`
          )
        }
        Avatar={CropIcon}
        title={baseAcres?.commodity_name}
        subtitle={baseAcres?.practice_name}
        action={
          <IconButton
            data-testid={baseAcres?.id}
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteOnClick();
            }}
          >
            <DeleteIcon />
          </IconButton>
        }
        details={[
          {
            value: formatNumber(baseAcres?.base_acreage, 0),
            label: "BASE ACRES",
          },
          {
            value: formatNumber(baseAcres?.plc_yield, 0),
            label: "PLC YIELD",
          },
        ]}
      />
      {confirmDialogComponent}
    </>
  );
}
